import React from 'react'
import { NavLink } from 'react-router-dom'
import { Body1 } from '../../../layouts/TextStyles'
import Document from '../../../assets/icons/Documents/Copy-Document-Filled.svg'
import styled from '@emotion/styled'
import { ui } from '../../../utils/uiTokens'

const MenuItem = ({ path, title }) => {
    return (
        <li>
            <NavLink to={path}>
                {({ isActive }) => (
                    <LinkContainer active={isActive}>
                        <img
                            alt="document-copyw"
                            src={Document}
                        />
                        <Body1>{title}</Body1>
                    </LinkContainer>
                )}
            </NavLink>
        </li>
    )
}

export { MenuItem }

const LinkContainer = styled.div<{ active: boolean }>`
    margin: 4px 0;
    display: grid;
    grid-template-columns: 18px auto;
    align-items: center;
    text-align: left;
    gap: 10px;
    padding: 10px;
    border-radius: 12px;
    background-color: ${({ active }) => (active ? ui.pinkSoft : 'transparent')};
    transition: background-color 0.15s ease;

    img {
        width: 18px;
        height: 18px;
        opacity: ${({ active }) => (active ? 1 : 0.45)};
    }

    p {
        font-size: 14px;
        font-weight: ${({ active }) => (active ? 600 : 400)};
        color: ${({ active }) => (active ? ui.pink : ui.sub)};
    }

    &:hover {
        background-color: ${({ active }) => (active ? ui.pinkSoft : '#FCFAFC')};

        p {
            color: ${({ active }) => (active ? ui.pink : ui.ink)};
        }
    }
`
